import { render, staticRenderFns } from "./bottomBg.vue?vue&type=template&id=221d051c&scoped=true&"
import script from "./bottomBg.vue?vue&type=script&lang=js&"
export * from "./bottomBg.vue?vue&type=script&lang=js&"
import style0 from "./bottomBg.vue?vue&type=style&index=0&id=221d051c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d051c",
  null
  
)

export default component.exports